module.exports = __webpack_public_path__ + "static/img/40007 (3).73a7576.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40007 (3).webp
// module id = TAUi
// module chunks = 14